export const formatToDailyAmount = (amount: number, days: number) => (amount / 100 / days).toFixed(2)
